import { ShieldCheck } from 'lucide-react';
import { Button } from '@zaogig/ui/button';

interface HomeHeaderProps {
  onLogin?: () => void;
}

export function HomeHeader({ onLogin }: HomeHeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-slate-50/95 backdrop-blur-sm border-b border-slate-200">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 h-16 sm:h-20">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white shadow-lg shadow-emerald-500/20">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <div className="hidden sm:block">
            <div className="font-bold text-slate-950">早知零工调度平台</div>
            <div className="text-xs text-slate-500">可信用工 · 智能调度 · 安心结算</div>
          </div>
        </div>

        <Button
          onClick={onLogin}
          className="rounded-full bg-gradient-to-r from-emerald-500 to-teal-600 px-4 py-2 text-sm font-bold text-white shadow-lg shadow-emerald-500/20 hover:-translate-y-0.5 hover:from-emerald-600 hover:to-teal-700 sm:px-5"
        >
          登录 / 注册
        </Button>
      </div>
    </header>
  );
}
